/* Peakspan Oxy v1.2 — vanilla JS. Page content works without JS;
   this only adds header state, mobile nav, carousels, tabs, PDP gallery. */
(function () {
  'use strict';

  /* ---------- header scroll state ---------- */
  var header = document.querySelector('.site-header');
  if (header && !header.classList.contains('site-header--solid')) {
    var onScroll = function () {
      header.classList.toggle('scrolled', window.scrollY > 40);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- mobile nav ---------- */
  var navToggle = document.querySelector('.nav-toggle');
  if (navToggle && header) {
    navToggle.addEventListener('click', function () {
      var open = header.classList.toggle('nav-open');
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    header.querySelectorAll('.mobile-panel a').forEach(function (a) {
      a.addEventListener('click', function () {
        header.classList.remove('nav-open');
      });
    });
  }

  /* ---------- carousels (scroll-by-card) ---------- */
  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    var track = root.querySelector('.car-track');
    if (!track) return;
    var step = function () {
      var card = track.querySelector(':scope > *');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return card.getBoundingClientRect().width + gap;
    };
    var bind = function (btn, dir) {
      if (!btn) return;
      btn.addEventListener('click', function () {
        track.scrollBy({ left: dir * step() * 2, behavior: 'smooth' });
      });
    };
    bind(root.querySelector('[data-car-prev]'), -1);
    bind(root.querySelector('[data-car-next]'), 1);
  });

  /* ---------- tabs (science section) ---------- */
  document.querySelectorAll('[data-tabs]').forEach(function (root) {
    var pills = root.querySelectorAll('[data-tab]');
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var name = pill.getAttribute('data-tab');
        pills.forEach(function (p) { p.classList.toggle('active', p === pill); });
        root.querySelectorAll('[data-panel]').forEach(function (panel) {
          panel.classList.toggle('is-hidden', panel.getAttribute('data-panel') !== name);
        });
      });
    });
  });

  /* ---------- PDP gallery ---------- */
  var pdpMain = document.querySelector('[data-pdp-main] img');
  if (pdpMain) {
    var thumbs = document.querySelectorAll('.pdp-thumb');
    var count = document.querySelector('[data-pdp-count]');
    var idx = 0;
    var show = function (i) {
      idx = (i + thumbs.length) % thumbs.length;
      thumbs.forEach(function (t, n) { t.classList.toggle('active', n === idx); });
      var img = thumbs[idx].querySelector('img');
      if (img) { pdpMain.src = img.src; pdpMain.alt = img.alt; }
      if (count) count.textContent = (idx + 1) + ' / ' + thumbs.length;
    };
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
    var prev = document.querySelector('[data-pdp-prev]');
    var next = document.querySelector('[data-pdp-next]');
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });
  }

  /* ---------- PDP enquiry option toggles ATC label ---------- */
  var optInputs = document.querySelectorAll('.pdp-opt input[name="purchase_mode"]');
  var atcBtn = document.querySelector('[data-atc-label]');
  if (optInputs.length && atcBtn) {
    var selectedMode = function () {
      var selected = document.querySelector('.pdp-opt input[name="purchase_mode"]:checked');
      return selected ? selected.value : 'buy';
    };
    var updateAtcLabel = function () {
      atcBtn.textContent = selectedMode() === 'enquiry' ? 'Enquire now' : (atcBtn.getAttribute('data-atc-label') || 'Add to cart');
    };
    optInputs.forEach(function (input) {
      input.addEventListener('change', updateAtcLabel);
    });
    updateAtcLabel();
    var atcForm = atcBtn.closest('form');
    if (atcForm) {
      atcForm.addEventListener('submit', function (event) {
        if (selectedMode() !== 'enquiry') return;
        event.preventDefault();
        var enquiryUrl = atcBtn.getAttribute('data-enquiry-url') || '/pages/contact';
        window.location.assign(enquiryUrl + '?product=' + encodeURIComponent(window.location.pathname));
      });
    }
  }

  /* ---------- cart quantity steppers ---------- */
  document.querySelectorAll('.cart-qty').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var dec = wrap.querySelector('[data-qty-dec]');
    var inc = wrap.querySelector('[data-qty-inc]');
    if (!input) return;
    if (dec) dec.addEventListener('click', function () { input.value = Math.max(0, (parseInt(input.value, 10) || 0) - 1); });
    if (inc) inc.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 0) + 1; });
  });

  var openDialog = function (dialog) {
    if (!dialog || dialog.open) return;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  };

  var closeDialog = function (dialog) {
    if (!dialog || !dialog.open) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  };

  var storageRead = function (key) {
    try { return window.localStorage.getItem(key); } catch (error) { return null; }
  };

  var storageWrite = function (key, value) {
    try { window.localStorage.setItem(key, value); } catch (error) { return; }
  };

  var mailingDialog = document.querySelector('[data-mailing-popup]');
  if (mailingDialog) {
    var mailingStorageKey = 'peakspan_mailing_popup_dismissed_v1';
    var mailingDismissedAt = parseInt(storageRead(mailingStorageKey), 10) || 0;
    var mailingDismissalAge = Date.now() - mailingDismissedAt;
    var mailingShouldOpen = !mailingDismissedAt || mailingDismissalAge > 2592000000;
    var mailingSubmitted = mailingDialog.querySelector('[data-mailing-success]');
    var mailingErrors = mailingDialog.querySelector('.errors');
    var dismissMailing = function () {
      storageWrite(mailingStorageKey, String(Date.now()));
      closeDialog(mailingDialog);
    };
    mailingDialog.querySelectorAll('[data-mailing-dismiss]').forEach(function (button) {
      button.addEventListener('click', dismissMailing);
    });
    mailingDialog.addEventListener('cancel', function () {
      storageWrite(mailingStorageKey, String(Date.now()));
    });
    mailingDialog.addEventListener('click', function (event) {
      if (event.target === mailingDialog) dismissMailing();
    });
    if (mailingSubmitted || mailingErrors) openDialog(mailingDialog);
    else if (mailingShouldOpen) window.setTimeout(function () { openDialog(mailingDialog); }, 1200);
  }

  var recentRoot = document.querySelector('[data-recently-viewed]');
  var recentList = document.querySelector('[data-recently-viewed-list]');
  if (recentRoot && recentList) {
    var recentStorageKey = 'peakspan_recently_viewed_v1';
    var recentItems = [];
    try {
      var storedRecentItems = JSON.parse(storageRead(recentStorageKey) || '[]');
      if (Array.isArray(storedRecentItems)) recentItems = storedRecentItems;
    } catch (error) {
      recentItems = [];
    }
    var currentProduct = null;
    var currentProductData = document.querySelector('[data-recent-product]');
    if (currentProductData) {
      try { currentProduct = JSON.parse(currentProductData.textContent); } catch (error) { currentProduct = null; }
    }
    recentItems = recentItems.filter(function (item) {
      return item && typeof item.handle === 'string' && typeof item.title === 'string' && typeof item.url === 'string';
    });
    if (currentProduct && currentProduct.handle) {
      recentItems = recentItems.filter(function (item) { return item.handle !== currentProduct.handle; });
      recentItems.unshift(currentProduct);
      recentItems = recentItems.slice(0, 6);
      storageWrite(recentStorageKey, JSON.stringify(recentItems));
    }
    var displayedRecentItems = recentItems.filter(function (item) {
      return !currentProduct || item.handle !== currentProduct.handle;
    }).slice(0, 4);
    var safeProductUrl = function (value) {
      try {
        var url = new URL(value, window.location.origin);
        if (url.origin !== window.location.origin) return '';
        return url.pathname + url.search + url.hash;
      } catch (error) {
        return '';
      }
    };
    var safeImageUrl = function (value) {
      if (typeof value !== 'string') return '';
      try {
        var url = new URL(value, window.location.origin);
        return url.protocol === 'http:' || url.protocol === 'https:' ? url.href : '';
      } catch (error) {
        return '';
      }
    };
    displayedRecentItems.forEach(function (item) {
      var productUrl = safeProductUrl(item.url);
      if (!productUrl) return;
      var card = document.createElement('article');
      var link = document.createElement('a');
      var imageUrl = safeImageUrl(item.image);
      var body = document.createElement('span');
      var title = document.createElement('span');
      var price = document.createElement('span');
      card.className = 'ps-recent__card';
      card.setAttribute('role', 'listitem');
      link.href = productUrl;
      link.className = 'ps-recent__link';
      if (imageUrl) {
        var image = document.createElement('img');
        image.src = imageUrl;
        image.alt = item.title;
        image.loading = 'lazy';
        image.width = 600;
        image.height = 450;
        link.appendChild(image);
      }
      body.className = 'ps-recent__body';
      title.className = 'ps-recent__title';
      title.textContent = item.title;
      price.className = 'ps-recent__price';
      price.textContent = typeof item.price === 'string' ? item.price : '';
      body.appendChild(title);
      if (price.textContent) body.appendChild(price);
      link.appendChild(body);
      card.appendChild(link);
      recentList.appendChild(card);
    });
    if (recentList.children.length) recentRoot.hidden = false;
  }

  var cartDialog = document.querySelector('[data-cart-confirmation]');
  var cartLive = document.querySelector('[data-cart-live]');
  var lastCartTrigger = null;
  if (cartDialog) {
    cartDialog.querySelectorAll('[data-cart-close]').forEach(function (button) {
      button.addEventListener('click', function () { closeDialog(cartDialog); });
    });
    cartDialog.addEventListener('click', function (event) {
      if (event.target === cartDialog) closeDialog(cartDialog);
    });
    cartDialog.addEventListener('close', function () {
      if (lastCartTrigger) lastCartTrigger.focus();
    });
  }

  var updateCartCount = function (count) {
    document.querySelectorAll('.cart-count').forEach(function (counter) {
      counter.textContent = String(count);
      counter.setAttribute('aria-label', count + (count === 1 ? ' item in cart' : ' items in cart'));
    });
    document.querySelectorAll('[data-cart-drawer-count]').forEach(function (counter) {
      counter.textContent = String(count);
    });
  };

  var showCartConfirmation = function (item, cart, trigger) {
    var title = item.product_title || item.title || 'Item';
    var suffix = '';
    lastCartTrigger = trigger;
    if (cartDialog) {
      var message = cartDialog.querySelector('[data-cart-message]');
      if (message) {
        suffix = message.getAttribute('data-added-suffix') || '';
        message.textContent = title + ' ' + suffix;
      }
      openDialog(cartDialog);
    }
    if (cartLive) cartLive.textContent = title + ' ' + (suffix || 'was added to your cart.');
    updateCartCount(cart.item_count);
  };

  if (!document.body.classList.contains('commerce-hold')) {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        if (event.defaultPrevented || form.getAttribute('data-cart-busy') === 'true') return;
        var purchaseMode = form.closest('.pdp-buybox') && document.querySelector('input[name="purchase_mode"]:checked');
        if (purchaseMode && purchaseMode.value === 'enquiry') return;
        event.preventDefault();
        var submitButton = event.submitter || form.querySelector('[type="submit"]');
        var originalLabel = submitButton ? submitButton.textContent : '';
        var addUrl = document.body.getAttribute('data-cart-add-url');
        var cartUrl = document.body.getAttribute('data-cart-url');
        if (!addUrl || !cartUrl) return;
        form.setAttribute('data-cart-busy', 'true');
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.setAttribute('aria-busy', 'true');
          if (cartLive && cartLive.getAttribute('data-loading-label')) submitButton.textContent = cartLive.getAttribute('data-loading-label');
        }
        fetch(addUrl, {
          method: 'POST',
          body: new FormData(form),
          credentials: 'same-origin',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        }).then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (payload) {
            if (!response.ok) throw new Error(payload.description || 'Cart request failed');
            return payload;
          });
        }).then(function (item) {
          return fetch(cartUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
            .then(function (response) { return response.ok ? response.json() : null; })
            .catch(function () { return null; })
            .then(function (cart) {
              if (!cart) {
                var existingCount = parseInt((document.querySelector('.cart-count') || {}).textContent, 10) || 0;
                cart = { item_count: existingCount + (parseInt(item.quantity, 10) || 1) };
              }
              showCartConfirmation(item, cart, submitButton);
            });
        }).catch(function () {
          if (cartLive) cartLive.textContent = cartLive.getAttribute('data-error-label') || 'We could not confirm that item. Please try again.';
        }).finally(function () {
          form.removeAttribute('data-cart-busy');
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.removeAttribute('aria-busy');
            submitButton.textContent = originalLabel;
          }
        });
      });
    });
  }
})();

/* ============================================================
   Peakspan Oxy v1.2 === v1.2 LIT sections ===
   Quiz modal, PDP config picker (price/spec swap), sticky CTA bar,
   range page anchor nav. Existing behaviors above are untouched.
   PDP gallery thumbs are handled by the original v1 block (it binds
   [data-pdp-main] + .pdp-thumb), which the v1.2 PDP markup reuses.
   ============================================================ */
(function () {
  'use strict';

  var openDialogV12 = function (dialog) {
    if (!dialog || dialog.open) return;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  };
  var closeDialogV12 = function (dialog) {
    if (!dialog || !dialog.open) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  };

  /* ---------- quiz modal ---------- */
  var quiz = document.querySelector('[data-quiz]');
  if (quiz) {
    var quizData = {};
    var quizDataEl = document.querySelector('[data-quiz-data]');
    if (quizDataEl) {
      try { quizData = JSON.parse(quizDataEl.textContent); } catch (error) { quizData = {}; }
    }
    var heading = quiz.querySelector('[data-quiz-heading]');
    var stepLabel = quiz.querySelector('[data-quiz-step-label]');
    var steps = quiz.querySelectorAll('[data-quiz-step]');
    var result = quiz.querySelector('[data-quiz-result]');
    var answers = { goal: null, space: null, budget: null };
    var headings = { 1: 'What are you here for?', 2: 'Where would it live?', 3: 'What is the budget?' };

    var recommend = function () {
      /* BUILD-SPEC §3 default logic: goal→category, budget→tier, 'all'+garden→contrast-ritual */
      var g = answers.goal, s = answers.space, b = answers.budget;
      if (g === 'recovery') {
        if (b === 'u6') return ['frost-air', 'Complete kit under AED 6k — the insulated tub, the chiller and the desk light in one box.'];
        if (b === 'u20') return ['frost-pro', 'Heats and cools — the serious home chiller inside your budget.'];
        return ['solstice', 'The cedar all-in-one — furniture, not equipment, and the top of the cold line.'];
      }
      if (g === 'sleep') {
        if (s === 'garden') return ['chloe', 'The outdoor curved cabin — built to live in a garden.'];
        if (b === 'o40') return ['duo', 'Finnish heat and infrared in one cabin — the hybrid, four seats wide.'];
        return ['nora', 'The indoor traditional sauna — the sauna line starts here at AED 33,140.'];
      }
      if (g === 'skin') {
        if (b === 'u6') return ['halo-60', 'Seven wavelengths, desk-sized — the panel to start with.'];
        if (b === 'u20') return ['meridian-450', 'Full-body coverage: stand in front of it once.'];
        return ['zenith-1200', 'The wall — 864 emitters across nine wavelengths.'];
      }
      if (s === 'garden') return ['contrast-ritual', 'Plunge plus sauna — the contrast room a garden can hold.'];
      if (b === 'u6' || b === 'u20') return ['morning-protocol', 'Cold and light together — the two-piece morning routine, bundled for less.'];
      if (b === 'u40') return ['contrast-ritual', 'Cold plunge plus sauna — the full contrast room, bundled for less.'];
      return ['penthouse-suite', 'Everything Peakspan makes — plunge, sauna and the wall of light, bundled for less.'];
    };

    var showStep = function (n) {
      steps.forEach(function (step) {
        step.hidden = step.getAttribute('data-quiz-step') !== String(n);
      });
      if (result) result.hidden = true;
      if (heading) heading.textContent = headings[n] || '';
      if (stepLabel) stepLabel.textContent = 'Step ' + n + ' of 3';
    };

    var showResult = function () {
      var pick = recommend();
      var product = quizData[pick[0]];
      if (!product) return;
      steps.forEach(function (step) { step.hidden = true; });
      if (heading) heading.textContent = 'Your setup';
      if (stepLabel) stepLabel.textContent = 'Recommendation';
      var nameEl = quiz.querySelector('[data-quiz-name]');
      var priceEl = quiz.querySelector('[data-quiz-price]');
      var pitchEl = quiz.querySelector('[data-quiz-pitch]');
      var whyEl = quiz.querySelector('[data-quiz-why]');
      var viewEl = quiz.querySelector('[data-quiz-view]');
      var regEl = quiz.querySelector('[data-quiz-register]');
      if (nameEl) nameEl.textContent = product.name;
      if (priceEl) priceEl.textContent = 'Launch price — from AED ' + product.price;
      if (pitchEl) pitchEl.textContent = product.pitch;
      if (whyEl) whyEl.textContent = pick[1];
      if (viewEl) viewEl.href = product.url;
      if (regEl) regEl.href = '/pages/contact?product=' + encodeURIComponent(product.name);
      if (result) result.hidden = false;
    };

    quiz.querySelectorAll('[data-quiz-pick]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        answers[btn.getAttribute('data-quiz-pick')] = btn.getAttribute('data-value');
        if (!answers.goal) showStep(1);
        else if (!answers.space) showStep(2);
        else if (!answers.budget) showStep(3);
        else showResult();
      });
    });
    var restartBtn = quiz.querySelector('[data-quiz-restart]');
    if (restartBtn) restartBtn.addEventListener('click', function () {
      answers.goal = answers.space = answers.budget = null;
      showStep(1);
    });
    quiz.querySelectorAll('[data-quiz-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { closeDialogV12(quiz); });
    });
    quiz.addEventListener('click', function (event) {
      if (event.target === quiz) closeDialogV12(quiz);
    });
    document.querySelectorAll('[data-quiz-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        showStep(answers.goal ? (answers.space ? (answers.budget ? 3 : 3) : 2) : 1);
        if (answers.goal && answers.space && answers.budget) showResult();
        openDialogV12(quiz);
      });
    });
  }

  /* ---------- PDP config picker (price / spec swap) ---------- */
  var configWrap = document.querySelector('[data-pdp-configs]');
  if (configWrap) {
    var priceEl = document.querySelector('[data-pdp-price]');
    var detailEl = configWrap.querySelector('[data-pdp-config-detail]');
    var applyConfig = function (input) {
      if (!input) return;
      if (priceEl && input.getAttribute('data-config-price')) priceEl.textContent = input.getAttribute('data-config-price');
      if (detailEl) detailEl.textContent = input.getAttribute('data-config-detail') || '';
    };
    configWrap.querySelectorAll('input[name="pdp_config"]').forEach(function (input) {
      input.addEventListener('change', function () { applyConfig(input); });
    });
    applyConfig(configWrap.querySelector('input[name="pdp_config"]:checked'));
  }

  /* ---------- PDP sticky CTA bar ---------- */
  var stickyBar = document.querySelector('[data-sticky-bar]');
  var buybox = document.querySelector('[data-pdp-buybox]');
  if (stickyBar && buybox) {
    if ('IntersectionObserver' in window) {
      var pastBuybox = false;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          pastBuybox = entry.boundingClientRect.bottom < 0 && !entry.isIntersecting;
          stickyBar.hidden = !pastBuybox;
        });
      }, { threshold: 0 });
      observer.observe(buybox);
    } else {
      var onStickyScroll = function () {
        stickyBar.hidden = buybox.getBoundingClientRect().bottom >= 0;
      };
      onStickyScroll();
      window.addEventListener('scroll', onStickyScroll, { passive: true });
    }
  }

  /* ---------- range page anchor nav ---------- */
  var rangeNav = document.querySelector('[data-range-nav]');
  if (rangeNav) {
    var navLinks = rangeNav.querySelectorAll('a[href^="#"]');
    navLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        navLinks.forEach(function (l) { l.classList.toggle('active', l === link); });
      });
    });
    if ('IntersectionObserver' in window) {
      var sections = [];
      navLinks.forEach(function (link) {
        var target = document.querySelector(link.getAttribute('href'));
        if (target) sections.push({ link: link, target: target });
      });
      var navObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          sections.forEach(function (s) {
            if (s.target === entry.target) {
              navLinks.forEach(function (l) { l.classList.toggle('active', l === s.link); });
            }
          });
        });
      }, { rootMargin: '-30% 0px -60% 0px' });
      sections.forEach(function (s) { navObserver.observe(s.target); });
    }
  }
})();
